import React from 'react';

const LogoSVG = ({ width = 200, height = 60, iconOnly = false }) => {
  if (iconOnly) {
    return (
      <svg width={height} height={height} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        {/* Flower/Aperture design */}
        <g transform="translate(50,50)">
          {/* Top petal - blue */}
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#0066CC" />
          {/* Top-right petal - light blue */}
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#00ACC1" transform="rotate(72)" />
          {/* Bottom-right petal - pink */}
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#FF1744" transform="rotate(144)" />
          {/* Bottom-left petal - red */}
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#DC004E" transform="rotate(216)" />
          {/* Top-left petal - dark blue */}
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#1A1A2E" transform="rotate(288)" />
          {/* Center circle */}
          <circle cx="0" cy="0" r="12" fill="white" />
        </g>
      </svg>
    );
  }

  return (
    <svg width={width} height={height} viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg">
      {/* Icon */}
      <g transform="translate(40,40)">
        {/* Flower/Aperture design - scaled down */}
        <g transform="scale(0.8)">
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#0066CC" />
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#00ACC1" transform="rotate(72)" />
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#FF1744" transform="rotate(144)" />
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#DC004E" transform="rotate(216)" />
          <path d="M 0,-40 Q -15,-20 -15,0 Q 0,-10 15,0 Q 15,-20 0,-40" fill="#1A1A2E" transform="rotate(288)" />
          <circle cx="0" cy="0" r="12" fill="white" />
        </g>
      </g>
      
      {/* Text */}
<text x="90" y="45" fontFamily="Arial, sans-serif" fontSize="32" fontWeight="700" fill="#1A1A2E">
  OMEGA
</text>
<text x="90" y="62" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="400" fill="#5A5A5A">
  PHOTO AND RECORDING STUDIO
</text>

    </svg>
  );
};

export default LogoSVG;
